import mapSliceToComponent from '~/imports/universal_page'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import SliceManager from '~/components/Abstracts/SliceManager'
import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import TwoColumnsLayoutLine from '~/components/Slices/TwoColumnsLayoutLine'

import { getStaticPathsFunction } from '~/data/page-data'
import getPressArticlePageStaticPropsFunction from '~/data/press-article-page-data'
import { PressArticlePageData } from '~/data/press-article-page-data/serializer'

import css from '../styles.module.scss'

function PressArticlePage({ slices, hero, ...props }: PressArticlePageData) {
  return (
    <section className={css.PressArticlePage}>
      {hero && <TwoColumnsLayoutLine {...hero} isHero />}
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
      />
      <PageViewAnalytics template="page" />
    </section>
  )
}

export default PressArticlePage

export const getStaticProps = getPressArticlePageStaticPropsFunction()
export const getStaticPaths = getStaticPathsFunction({
  type: STORYBLOK_TYPES.PRESS_ARTICLE_PAGE,
})
